import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';

export function initAnalytics() {
  if (!POSTHOG_KEY) return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false, // manual via router
    loaded: (ph) => {
      if (import.meta.env.DEV) ph.opt_out_capturing();
    },
  });
}

export function identifyUser(userId: string, props?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return;
  posthog.identify(userId, props);
}

export function resetUser() {
  if (!POSTHOG_KEY) return;
  posthog.reset();
}

export function capture(event: string, props?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return;
  posthog.capture(event, props);
}

// Typed events
export const Analytics = {
  signUp: (method = 'email') => capture('signup', { method }),
  signIn: () => capture('signin'),
  signOut: () => capture('signout'),
  situationCreated: (id: string) => capture('situation_created', { situation_id: id }),
  chatStarted: (situationId?: string) => capture('chat_started', { situation_id: situationId }),
  voiceStarted: (situationId?: string) => capture('voice_started', { situation_id: situationId }),
  checkoutInitiated: (plan: string) => capture('checkout_initiated', { plan }),
  subscriptionActivated: (plan: string) => capture('subscription_activated', { plan }),
  paywallShown: (feature: string) => capture('paywall_shown', { feature }),
  pageViewed: (path: string) => capture('', { '': path }),
  voiceHint: (level: number, slug?: string) => capture('voice_hint', { level, slug }),
  reviewUncertain: (slug?: string) => capture('review_uncertain', { slug }),
};
